import { api } from '../config'
import { AxiosResponse } from 'axios'
import { UserInfo } from '../../redux/User/types'

export const getUserInfoService = async () => {
  const { data }: AxiosResponse<UserInfo> = await api.get('/api/creators')

  return data
}
